import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
var __jsx = React.createElement;
import * as React from 'react';
import styled, { css } from 'styled-components';
import { useInView } from 'react-intersection-observer';
import * as ds from '@bob/design-system';
import { Framed, Illustration, Video, RichText, ProductCard } from '@bob/rich-text';
import { SocialShare } from '../../../../components/share/SocialShare';
import { ShareGroup } from '../../../../components/share/ShareGroup';
export function Content(_ref) {
  var article = _ref.article,
      setReadTime = _ref.setReadTime,
      url = _ref.url;

  var _useInView = useInView({
    rootMargin: '85px'
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      shareGroupRef = _useInView2[0],
      shareGroupInView = _useInView2[1];

  var _useInView3 = useInView({
    threshold: 0.05,
    triggerOnce: true
  }),
      _useInView4 = _slicedToArray(_useInView3, 2),
      stickyRef = _useInView4[0],
      stickyInView = _useInView4[1];

  var sectionRef = React.useRef(null);
  React.useEffect(function () {
    var _sectionRef$current;

    // TODO: count words server side
    if ((_sectionRef$current = sectionRef.current) !== null && _sectionRef$current !== void 0 && _sectionRef$current.textContent) {
      var wordCount = sectionRef.current.textContent.split(' ').length;
      var readTime = (wordCount / 230).toFixed(0);
      setReadTime(readTime);
    }
  }, []);
  return __jsx(React.Fragment, null, __jsx(Section, {
    ref: sectionRef
  }, __jsx(ConditionalDisplay, null, __jsx(SocialShare, {
    url: url,
    title: article.title,
    text: article.description
  })), __jsx(RichTextWrapper, null, __jsx(RichText, {
    document: article.content.json,
    links: article.content.links,
    renderEntry: renderEntry
  })), __jsx(Sticky, {
    ref: stickyRef,
    appearTransition: stickyInView,
    disappearTransition: shareGroupInView
  }, __jsx(SocialShare, {
    column: true,
    buttonLabel: "Partager l'article",
    url: url,
    title: article.title,
    text: article.description
  }))), __jsx(ConditionalDisplay, {
    visible: true,
    ref: shareGroupRef
  }, __jsx(ShareGroupStyled, {
    url: url,
    title: article.title,
    text: article.description,
    buttonLabel: "Partager l'article"
  }, __jsx(Hint, null, "Vous avez aim\xE9 cet article ? Partagez-le !"))));

  function renderEntry(entry) {
    if (entry.__typename === 'Illustration') {
      return __jsx(Illustration, entry);
    }

    if (entry.__typename === 'Video') {
      return __jsx(Video, entry);
    }

    if (entry.__typename === 'Framed') {
      return __jsx(Framed, entry);
    }

    if (entry.__typename === 'ProductCard') {
      if (entry.product) {
        return __jsx(ProductCard, {
          align: entry.align,
          product: entry.product
        });
      }
    }
  }
}
var RichTextWrapper = styled.div.withConfig({
  displayName: "Content__RichTextWrapper",
  componentId: "sc-1ow0m65-0"
})(["width:100%;"]);
var Section = styled.section.withConfig({
  displayName: "Content__Section",
  componentId: "sc-1ow0m65-1"
})(["position:relative;@media screen and (", "){background-color:", ";border-radius:12px;display:flex;padding:40px 110px;}", "{display:block;padding-left:25%;padding-right:25%;}"], ds.breakpoint.TABLET, ds.color.SAND_2, ds.Button);
var Sticky = styled.div.withConfig({
  displayName: "Content__Sticky",
  componentId: "sc-1ow0m65-2"
})(["", "{display:none;@media screen and (", "){display:flex;margin-left:55px;opacity:0;position:sticky;top:110px;transition-duration:300ms;transition-property:transform,opacity;", " ", "}}"], ds.SocialShare, ds.breakpoint.TABLET, function (_ref2) {
  var appearTransition = _ref2.appearTransition;

  if (appearTransition) {
    return css(["opacity:1;"]);
  }
}, function (_ref3) {
  var disappearTransition = _ref3.disappearTransition;

  if (disappearTransition) {
    return css(["transform:translateY(-280px);"]);
  }
});
var ConditionalDisplay = styled.div.withConfig({
  displayName: "Content__ConditionalDisplay",
  componentId: "sc-1ow0m65-3"
})(["height:120px;width:100%;display:flex;align-items:center;justify-content:center;@media screen and (", "){height:auto;", "}"], ds.breakpoint.TABLET, function (_ref4) {
  var visible = _ref4.visible;
  return visible ? css(["display:flex;"]) : css(["display:none;"]);
});
var Hint = styled.div.withConfig({
  displayName: "Content__Hint",
  componentId: "sc-1ow0m65-4"
})(["margin-bottom:10px;"]);
var ShareGroupStyled = styled(ShareGroup).withConfig({
  displayName: "Content__ShareGroupStyled",
  componentId: "sc-1ow0m65-5"
})(["", "{display:none;@media screen and (", "){display:block;}}"], Hint, ds.breakpoint.TABLET);